module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1200.ac3d1fc7.svg";